module.exports = __webpack_public_path__ + "static/media/Calendar-black.fd25cc4d.svg";